export default "__VITE_ASSET__59d9dead__"